import { render, staticRenderFns } from "./CalendarioA.vue?vue&type=template&id=038b6278"
import script from "./CalendarioA.vue?vue&type=script&lang=js"
export * from "./CalendarioA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports